import { projectsProjectAccessDecisionCapability } from '@crest/module-projects/contracts/project-access-decision';
import { projectsProjectReferenceAccessHoldCapability, projectsProjectReferenceCapability, } from '@crest/module-projects/contracts/project-reference';
import { projectsProjectDetailHostCapability } from '@crest/module-projects/contracts/detail-host';
import { projectsProjectDetailLauncherCapability } from '@crest/module-projects/contracts/detail-launcher';
import { defineCrestModule } from '@crest/platform-contracts/modules';
import { platformOptionalFactProviderHostCapability } from '@crest/platform-contracts/hosts';
import { platformStorageObjectReferenceCapability } from '@crest/platform-contracts/storage';
import { scanningMediaBoundaryCorrectionCapability, scanningMediaCoordinateContinuityCapability, scanningMediaInsuranceClaimsReadinessProviderId, scanningMediaScanAssetsCapability, scanningMediaScanAssemblyCapability, } from './contracts/index.js';
import { scanningMediaMeasurementQuantitiesCapability, scanningMediaSemanticGeometryCapability, } from './contracts/scanning-media-semantic-geometry.contract.js';
import { scanningMediaQualityEventsCapability, scanningMediaScanCapturesCapability, } from './contracts/scanning-media-scan-capture.contract.js';
export const scanningMediaModuleManifest = defineCrestModule({
    id: 'scanning-media',
    version: '1.0.0',
    kind: 'business',
    required: false,
    requires: ['platform', 'projects'],
    requiredCapabilities: [
        'platform.tenant-context.v1',
        'platform.module-access.v1',
        projectsProjectReferenceCapability,
        projectsProjectReferenceAccessHoldCapability,
        projectsProjectAccessDecisionCapability,
        projectsProjectDetailHostCapability,
        projectsProjectDetailLauncherCapability,
        platformStorageObjectReferenceCapability,
        platformOptionalFactProviderHostCapability,
    ],
    optionalCapabilities: [],
    optionalCapabilityFallbacks: [],
    provides: [
        scanningMediaScanCapturesCapability,
        scanningMediaSemanticGeometryCapability,
        scanningMediaMeasurementQuantitiesCapability,
        scanningMediaQualityEventsCapability,
        scanningMediaBoundaryCorrectionCapability,
        scanningMediaScanAssemblyCapability,
        scanningMediaScanAssetsCapability,
        scanningMediaCoordinateContinuityCapability,
    ],
    permissions: [
        'scanning-media.scans.read',
        'scanning-media.scans.capture',
        'scanning-media.scans.review',
        'scanning-media.quality-events.record',
        'scanning-media.assembly.read',
        'scanning-media.assembly.review',
        'scanning-media.assets.read',
        'scanning-media.assets.manage',
        'scanning-media.coordinate-continuity.read',
        'scanning-media.coordinate-continuity.review',
    ],
    settings: [
        'scanning-media.scans.configuration',
        'scanning-media.scans.display',
        'scanning-media.copy.scans',
        'scanning-media.assembly.configuration',
        'scanning-media.assembly.display',
        'scanning-media.copy.assembly',
        'scanning-media.assets.configuration',
        'scanning-media.assets.display',
        'scanning-media.copy.assets',
        'scanning-media.coordinate-continuity.configuration',
        'scanning-media.coordinate-continuity.display',
        'scanning-media.copy.coordinate-continuity',
    ],
    copyCatalogs: [
        'scanning-media.copy.scans',
        'scanning-media.copy.assembly',
        'scanning-media.copy.assets',
        'scanning-media.copy.coordinate-continuity',
    ],
    events: {
        publishes: [
            'scanning-media.capture-created.v1',
            'scanning-media.capture-version-recorded.v1',
            'scanning-media.capture-version-accepted.v1',
            'scanning-media.capture-archived.v1',
            'scanning-media.capture-restored.v1',
            'scanning-media.quality-event-recorded.v1',
            'scanning-media.boundary-corrected.v1',
            'scanning-media.assembly-revision-saved.v1',
            'scanning-media.assembly-revision-accepted.v1',
            'scanning-media.scan-asset-register.v1',
            'scanning-media.scan-asset-finalize.v1',
            'scanning-media.scan-asset-quarantine.v1',
            'scanning-media.scan-asset-archive.v1',
            'scanning-media.coordinate-candidate-saved.v1',
            'scanning-media.coordinate-candidate-accepted.v1',
            'scanning-media.coordinate-candidate-rejected.v1',
        ],
        subscribes: [],
    },
    server: {
        routes: [
            { id: 'scanning-media.routes.scan-captures', priority: 0 },
            { id: 'scanning-media.routes.scan-assembly', priority: 10 },
            { id: 'scanning-media.routes.scan-assets', priority: 20 },
            { id: 'scanning-media.routes.coordinate-continuity', priority: 30 },
        ],
        jobs: [],
        subscribers: [],
        slots: [{
                id: scanningMediaInsuranceClaimsReadinessProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'scanning-media.scans.read',
                priority: 0,
            }],
    },
    web: {
        routes: [],
        navigation: [],
        slots: [{
                id: 'scanning-media.web.projects.scan-readback',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'scanning-media.scans.read',
                priority: 35,
            }, {
                id: 'scanning-media.web.projects.assembly-review',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'scanning-media.assembly.read',
                priority: 36,
            }, {
                id: 'scanning-media.web.projects.scan-assets',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'scanning-media.assets.read',
                priority: 37,
            }, {
                id: 'scanning-media.web.projects.coordinate-continuity',
                requiredCapability: 'projects.detail-host.v1',
                requiredPermission: 'scanning-media.coordinate-continuity.read',
                priority: 38,
            }],
    },
    mobile: {
        routes: [{
                id: 'scanning-media.mobile.scan-capture-contract',
                requiredPermission: 'scanning-media.scans.capture',
                priority: 0,
            }, {
                id: 'scanning-media.mobile.coordinate-continuity-contract',
                requiredPermission: 'scanning-media.coordinate-continuity.review',
                priority: 10,
            }],
        slots: [],
    },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'scanning_media',
        owns: [
            'scanning_media.scan_captures',
            'scanning_media.scan_capture_versions',
            'scanning_media.scan_floors',
            'scanning_media.scan_rooms',
            'scanning_media.scan_walls',
            'scanning_media.scan_openings',
            'scanning_media.scan_objects',
            'scanning_media.scan_quantities',
            'scanning_media.scan_quality_events',
            'scanning_media.scan_commands',
            'scanning_media.scan_assemblies',
            'scanning_media.scan_assembly_revisions',
            'scanning_media.scan_assembly_acceptances',
            'scanning_media.scan_assembly_commands',
            'scanning_media.scan_assets',
            'scanning_media.scan_asset_versions',
            'scanning_media.scan_asset_commands',
            'scanning_media.coordinate_continuities',
            'scanning_media.coordinate_stitch_candidates',
            'scanning_media.coordinate_stitch_sources',
            'scanning_media.coordinate_stitch_source_assets',
            'scanning_media.coordinate_stitch_relationships',
            'scanning_media.coordinate_stitch_decisions',
            'scanning_media.coordinate_continuity_commands',
            'scanning_media.execute_scan_command',
            'scanning_media.record_quality_event',
            'scanning_media.execute_scan_assembly_command',
            'scanning_media.scan_asset_content_type_allowed',
            'scanning_media.execute_scan_asset_command',
            'scanning_media.execute_coordinate_continuity_command',
        ],
        readsThrough: [
            projectsProjectReferenceCapability,
            projectsProjectReferenceAccessHoldCapability,
            projectsProjectAccessDecisionCapability,
            platformStorageObjectReferenceCapability,
        ],
        migrations: [
            'scanning-media.scan-capture-foundation',
            'scanning-media.assembly-boundary-correction',
            'scanning-media.scan-assets',
            'scanning-media.coordinate-continuity',
            'scanning-media.project-reference-mutation-holds',
        ],
    },
    health: ['scanning-media.database'],
    lifecycle: {
        initialization: { timeoutMs: 10_000, failureBehavior: 'quarantine-module' },
        resources: {
            requestConcurrency: 64,
            jobConcurrency: 0,
            queueBacklogLimit: 0,
            databaseConnectionBudget: 12,
            workerIsolation: 'shared-api',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'skip',
            events: {
                behavior: 'drop-safe',
                durableCursor: false,
                retentionDays: 0,
                backlogLimit: 0,
                warningAt: 0,
                reconciliationProcedure: null,
                dropSafeReason: 'The provider-neutral capture and asset-metadata slices publish retained facts but own no subscriber, worker, upload transport, or provider delivery path.',
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'finish-idempotently',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['scanning-media.database'],
            reconciliationProcedure: null,
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Scan identity, semantic, measurement, quality, assembly, coordinate, and private asset evidence remains retained while disabled.',
});
//# sourceMappingURL=scanning-media.module.js.map